module.exports = __webpack_public_path__ + "static/media/emptyData.12c3afe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/emptyData.png
// module id = 370
// module chunks = 0